export const POLICY_PATRIOTISM_UNIT_SIZE_DISCOUNT = 1;

export const POLICY_PATRIOTISM_BUILDING_DISCOUNT_ARSENAL = 4;
